/* eslint-disable no-console */
import {LockFilled} from '@ant-design/icons';
import {Divider, Flex, Progress} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import scopeOverviewBg from '../../../../assets/skeleton/scopeOverviewbg.png';
import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import BoxContent from '../../../../components/BoxContent/BoxContent';
import PilComp from '../../../../components/DisplayComponent/PilComp';
import sumTableValue from '../../../../components/Table/Utils/sumTableValue';
import UpgradeButton from '../../../../components/UpgradeButton/UpgradeButton';
import {
  blockAccessTypes,
  blockModelMessages,
  blockModelTypes
} from '../../../../constants/blockPageConstatnts';
import {Routes} from '../../../../constants/Routes';
import {formatIndian} from '../../../../utils/formatIndian';
import {roundToDecimal} from '../../../netZero/constants/commonFunctions';

import {DataScope} from './CommonData';
import {SCOPE_COLORS} from './constants/commonConstants';

const Scope: React.FC<{
  scopeData: DataScope[];
  scopeNumber: number;
  isBlock: boolean;
  totalEmissions?: number;
}> = ({scopeData = [], scopeNumber, isBlock, totalEmissions}) => {
  const navigate = useNavigate();
  const isScope3Locked = isBlock && scopeNumber === 3;
  const scopeTotal = roundToDecimal(
    sumTableValue(scopeData, 'value', false) as number
  );
  const percentage =
    totalEmissions != null && totalEmissions > 0
      ? roundToDecimal((scopeTotal / totalEmissions) * 100)
      : scopeTotal > 0
        ? 100
        : 0;

  return (
    <BoxContent noBackground={true}>
      <Flex
        className="scopeBoxContent"
        style={{
          flexDirection: 'column',
          height: '31.5rem'
        }}
      >
        {isScope3Locked ? (
          <div
            className="scopeLockedCard"
            style={{
              backgroundImage: `url(${scopeOverviewBg})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center'
            }}
          >
            <Flex className="scopeLockedWrap" vertical align="center" gap={18}>
              <div className="scopeLockIconWrap">
                <LockFilled className="scopeLockIcon" />
              </div>
              <Flex vertical align="center" gap={2}>
                <span className="scopeLockedTitle">Unlock Advanced</span>
                <span className="scopeLockedSubtitle">Scope 3 insights</span>
              </Flex>
              <div
                className="scopeUpgradeCta"
                onClick={() => {
                  navigate(Routes.PRICING_DETAILS);
                }}
              >
                <UpgradeButton
                  title="Upgrade"
                  style={{
                    height: 29,
                    minWidth: 102,
                    borderRadius: 4,
                    font: 'normal normal 700 14px Montserrat',
                    color: '#1B1D2A'
                  }}
                />
              </div>
            </Flex>
          </div>
        ) : (
          <>
            <div className="scopeEmissionSummary">
              <Flex
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Flex
                  style={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    flex: 1
                  }}
                >
                  <div className="sumEmission">
                    <span className="sumEmissionValue">
                      {formatIndian(scopeTotal)}
                    </span>
                    <span className="sumEmissionUnit">tCO2e</span>
                  </div>
                  <div className="totalCarbonEmission">
                    Scope {scopeNumber} Emissions
                  </div>
                </Flex>
                {isBlock ? null : (
                  <Flex
                    className="rightFlex"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      flex: 1
                    }}
                  >
                    <Progress
                      className="scopeDonutProgress"
                      style={{aspectRatio: '1', width: '75px'}}
                      type="circle"
                      percent={percentage}
                      format={() => `${percentage}%`}
                      showInfo={true}
                      trailColor="#D1DBE6"
                      strokeColor={
                        SCOPE_COLORS[scopeNumber]?.progress ?? '#0E4B72'
                      }
                      strokeWidth={10}
                      strokeLinecap="square"
                    />
                  </Flex>
                )}
              </Flex>
            </div>
            <Divider className="scopeDivider" />
            {isBlock && scopeNumber !== 3 ? (
              <BlockAccessPage
                messageTitle={blockModelMessages.scope.title.unlockMessage(
                  scopeNumber?.toString()
                )}
                messageDescription={blockModelMessages.scope.description.message(
                  scopeNumber?.toString()
                )}
                blockedType={blockAccessTypes.PARTIAL}
                modelType={blockModelTypes.SCOPE_NORMAL}
              />
            ) : null}
            {isBlock ? null : (
              <>
                <Flex className="emissionByTitle" justify="space-between">
                  <div>Emission by</div>
                  <div>tCO2e</div>
                </Flex>
                <div className="scopeEmissionList">
                  {scopeData?.map((item: DataScope, index) => (
                    <Flex key={index} className="listEmission">
                      <div className="listEmissionLabel">{item?.label}</div>
                      <PilComp
                        value={formatIndian(item?.value)}
                        color={SCOPE_COLORS[scopeNumber]?.pill ?? '#E5E7EB'}
                        style={{color: '#000000'}}
                      />
                    </Flex>
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </Flex>
    </BoxContent>
  );
};

export default Scope;
